const idaDisplayText=
{
Haemoglobin:"Haemoglobin (g/l)",
Ferritin:"Ferritin (ug/l)",
MCV:"MCV (fl)",
TIBC:"TIBC (umol/l)",
ironSat: "Iron Saturation (%)"
}

export default idaDisplayText
